import { consts } from "./consts.js";
import { selectLinkPopup } from "./select-link-popup.js";

export const fnMapToLink = (editor) => {
  const { componentName, canvasId, buttonName, wrapperName, traitTypes } = consts;

  let wr = editor.DomComponents.getWrapper();
  let wd = wr.view.el.clientWidth,
    ht = wr.view.el.clientHeight,
    // c = document.createElement("canvas"),
    canvas;

  let editorIframeBody = editor.Canvas.getBody();

  if (editorIframeBody.getElementsByTagName("canvas").length === 0) {
    canvas = document.createElement("canvas");
    canvas.height = ht;
    canvas.width = wd;
    canvas.attributes.id = canvasId;
    canvas.style.cssText = "position:absolute;top:0px;z-index: 9999999;";
    editorIframeBody.appendChild(canvas);
  } else {
    canvas = editorIframeBody.getElementsByTagName("canvas")[0];
    canvas.style.display = "block";
  }
  //console.log(canvas);

  let ctx = canvas.getContext("2d"),
    rect = {},
    drag = false;

  //canvasmapping.init(canvas, editor);

  let init = () => {
    canvas.addEventListener("mousedown", mouseDown, false);
    canvas.addEventListener("mouseup", mouseUp, false);
    canvas.addEventListener("mousemove", mouseMove, false);
  };

  function mouseDown(e) {
    rect.startX = e.pageX - this.offsetLeft;
    rect.startY = e.pageY - this.offsetTop;
    drag = true;
    canvas.removeEventListener("mousedown", mouseDown, false);
  }

  let mouseUp = async () => {
    drag = false;

    const changeTypeTraitOpts = Object.keys(traitTypes).map((type) => {
      const traitName = traitTypes[type];
      return { id: traitName, name: traitTypes[type] };
    });

    const callBackAfterCreatingPopup = (selectedType) => {
      if (selectedType) {
        const drawnComponent = {
          type: selectedType,
          droppable: false, // Can't drop any components inside this
          attributes: {
            "data-link-component": componentName,
          },
          style: {
            position: "absolute",
            top: rect.startY + "px",
            left: rect.startX + "px",
            width: rect.w + "px",
            height: rect.h + "px",
            display: "block",
          },
        };

        const wrapperComponentArray = editor.getWrapper().findType(wrapperName);
        let addedComponent;
        const popupComponents = editor.getWrapper().find(`[data-role="custom-popup"]`);
        let popupToAppend = null;
        if (popupComponents.length > 0 && drawnComponent.type !== "custom-popup") {
          for (const popup of popupComponents) {
            const popupStyles = popup.getStyle();
            const displayValue = popupStyles.display;
            if (displayValue !== "none") {
              popupToAppend = popup;
            }
          }
        }
        if (popupToAppend) {
          const popupToAppendContent = popupToAppend.find(`[data-role="popup-content"]`)[0];
          addedComponent = popupToAppendContent.append(drawnComponent)[0];
        } else if (wrapperComponentArray.length > 0) {
          const wrapperComponent = wrapperComponentArray[0];
          addedComponent = wrapperComponent.append(drawnComponent)[0];
        } else {
          const domComponents = editor.DomComponents;
          addedComponent = domComponents.addComponent(drawnComponent);
        }
        addedComponent.setDragMode("absolute");
      }

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      canvas.style.display = "none";

      canvas.removeEventListener("mouseup", mouseUp, false);

      const drawButton = editor.Panels.getButton("basic-actions", buttonName);
      drawButton.set("active", false);
    };

    selectLinkPopup(editor, changeTypeTraitOpts, callBackAfterCreatingPopup);
  };

  function mouseMove(e) {
    if (drag) {
      rect.w = e.pageX - this.offsetLeft - rect.startX;
      rect.h = e.pageY - this.offsetTop - rect.startY;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      draw();
    }
  }

  let draw = () => {
    ctx.setLineDash([2]);
    ctx.strokeStyle = "#3b97e3";
    //ctx.strokeStyle = "#fff"
    ctx.lineWidth = 1;

    ctx.strokeRect(rect.startX, rect.startY, rect.w, rect.h);
  };

  init();
};
